import { Typography } from 'antd';

import { formatMDY } from 'utils/formatDate';

import { CERTIFICATE_COLUMNS } from 'pages/company-profile/components/tabs/contacts/companyCertificate/constants';
import { CONTACT_COLUMNS } from 'pages/company-profile/components/tabs/contacts/companyContact/constants';
import { LOCATION_COLUMNS } from 'pages/company-profile/components/tabs/contacts/companyLocation/constants';

import { QaSpecHelpContentLabel } from '../shared/QaSpecHelpContent';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';

import { CellRenderAction } from 'pages/company-profile/components/tabs/contacts/companyCertificate/hook';

export const getContactColumns = (hiddenFields = []) => {
  const columns = mappingColumns(CONTACT_COLUMNS, hiddenFields);

  const filter = columns?.filter(
    (item) => !hiddenFields.includes(item?.dataIndex)
  );

  return {
    columns: filter,
  };
};

export const getLocationColumns = (hiddenFields = []) => {
  const columns = mappingColumns(LOCATION_COLUMNS, hiddenFields);
  const filter = columns?.filter(
    (item) => !hiddenFields.includes(item?.dataIndex)
  );
  return {
    columns: filter,
  };
};

export const getCertificateColumns = (hiddenFields = [], setStateActions) => {
  const columns = mappingColumns(CERTIFICATE_COLUMNS);

  const customColumns = [
    ...columns,
    {
      title: (
        <QaSpecHelpContentLabel
          fieldPath={TOOlTIP_FIELDS.certificateExpiryDate.fieldPath}
        >
          <Typography.Text strong>Certificate Expiry Date</Typography.Text>
        </QaSpecHelpContentLabel>
      ),
      dataIndex: 'expirationDate',
      width: 200,
      render: (value, _) => {
        return (
          <Typography.Text ellipsis={{ tooltip: formatMDY(value) }}>
            {formatMDY(value)}
          </Typography.Text>
        );
      },
    },
    {
      title: <Typography.Text strong>Actions</Typography.Text>,
      dataIndex: 'actions',
      render: (_, record) => {
        return (
          <CellRenderAction data={record} setStateActions={setStateActions} />
        );
      },
    },
  ];

  const filter = customColumns?.filter(
    (item) => !hiddenFields.includes(item?.dataIndex)
  );

  return {
    columns: filter,
  };
};

export const mappingColumns = (columns) => {
  return columns.map((item) => {
    const { title, fieldName, width, fieldPath } = item || {};
    return {
      title: (
        <QaSpecHelpContentLabel fieldPath={fieldPath}>
          <Typography.Text strong>{title}</Typography.Text>
        </QaSpecHelpContentLabel>
      ),
      dataIndex: fieldName,
      width: width ?? 150,
      render: (value, _) => {
        return (
          <Typography.Text ellipsis={{ tooltip: value }}>
            {value}
          </Typography.Text>
        );
      },
    };
  });
};
